import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import * as service from 'service'
import { routes } from 'Routes'

const DefaultComponent = ({ children }) => <>{children}</>

const RouteWithLayout = ({
  auth,
  layout,
  provider,
  component: Component,
  admin = false,
  redirect = true,
  ...rest
}) => {
  const Layout = layout || DefaultComponent
  const Provider = provider || DefaultComponent
  const isAuthenticated = service.intermediador.auth.isAuthenticated()

  if (!auth && isAuthenticated && redirect) {
    service.history.push(routes.home)
    return null
  }

  if (auth && !isAuthenticated) {
    service.history.push(routes.root)
    return null
  }

  const renderRoute = (matchProps) => {
    return (
      <Layout>
        <Provider component={Provider}>
          <Component {...matchProps} />
        </Provider>
      </Layout>
    )
  }

  return <Route {...rest} render={(matchProps) => renderRoute(matchProps)} />
}

RouteWithLayout.propTypes = {
  component: PropTypes.any,
  layout: PropTypes.any,
  path: PropTypes.string,
  permission: PropTypes.string,
  admin: PropTypes.bool,
}

export default RouteWithLayout
